/**
 * Frontend Configuration
 * 
 * Network semantics:
 * - Dynamic IP detection: Uses window.location.hostname to auto-detect access IP
 * - No Vite proxy needed - direct IP calls to backend
 * 
 * This approach:
 * - Works from localhost:9173 → connects to localhost:9900
 * - Works from LAN (192.168.1.x:9173) → connects to 192.168.1.x:9900
 * - Works from Tailscale (100.91.176.26:9173) → connects to 100.91.176.26:9900
 * - Avoids CORS issues (backend allows all origins in dev mode)
 */

// Dynamic IP detection from browser URL
const HOST_IP = typeof window !== 'undefined' 
  ? window.location.hostname 
  : (import.meta.env.VITE_HOST_IP || '192.168.1.165')

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || `http://${HOST_IP}:9900/api/v1`
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || `http://${HOST_IP}:9900`

/** Google-hosted Noto Animated Emoji Lottie assets. */
export const EMOJI_CDN_BASE_URL = 'https://fonts.gstatic.com/s/e/notoemoji/latest'

/** Upper bound for a single emoji animation request; a hung request must degrade to text. */
export const EMOJI_FETCH_TIMEOUT_MS = 5000

export const config = {
  API_BASE_URL,
  SOCKET_URL,
  HOST_IP,
  ENV: import.meta.env.MODE || 'development',
  apiUrl: API_BASE_URL,
  wsUrl: SOCKET_URL,
  appName: 'GIERMEK.online',
  version: '0.1.0'
}

export default config
